"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _layout = _interopRequireDefault(require("antd/lib/layout"));

var _react = _interopRequireDefault(require("react"));

var _logoMobile = _interopRequireDefault(require("../../assets/images/logo-mobile.png"));

var _logo = _interopRequireDefault(require("../../assets/images/logo.png"));

require("./sidebar.scss");

const SideBar = props => {
  const {
    collapsed,
    children
  } = props;
  const {
    Sider
  } = _layout.default;
  const logo = collapsed ? /*#__PURE__*/_react.default.createElement("div", {
    id: "logo-container-collapsed"
  }, /*#__PURE__*/_react.default.createElement("img", {
    id: "logo",
    src: _logoMobile.default,
    alt: "Logo"
  })) : /*#__PURE__*/_react.default.createElement("div", {
    id: "logo-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    id: "logo",
    src: _logo.default,
    alt: "Logo"
  }));
  return /*#__PURE__*/_react.default.createElement(Sider, {
    theme: "dark",
    className: "sidebar",
    trigger: null,
    collapsible: true,
    collapsed: collapsed
  }, logo, children);
};

var _default = SideBar;
exports.default = _default;